import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
export type SectionEyebrowProps = {
  /** Optional `01` numerator for `[01/02] LABEL` or `[01] LABEL`. Pass without padding — component pads. */
  index?: number;
  /** Optional total for `[NN/total] LABEL`. Requires `index`. */
  total?: number;
  label: string;
  className?: string;
};

/**
 * Marketing-page eyebrow: `[LABEL]` or `[01] LABEL` or `[01/02] LABEL` in
 * mono with the accent number/label colored.
 */
export function SectionEyebrow(t0) {
  const $ = _c(14);
  const {
    index,
    total,
    label,
    className
  } = t0;
  let t1;
  if ($[0] !== index) {
    t1 = index !== undefined ? String(index).padStart(2, "0") : null;
    $[0] = index;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const numerator = t1;
  let t2;
  if ($[2] !== total) {
    t2 = total !== undefined ? String(total).padStart(2, "0") : null;
    $[2] = total;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const denominator = t2;
  let t3;
  if ($[4] !== className) {
    t3 = cn("text-ds-alpha-shadow-30 font-mono text-base font-medium", className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span>[</span>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== denominator || $[8] !== label || $[9] !== numerator) {
    t5 = numerator ? <><span className="text-ds-brand-600">{numerator}</span><span>{denominator ? `/${denominator}] ${label}` : `] ${label}`}</span></> : <><span className="text-ds-brand-600">{label}</span><span>]</span></>;
    $[7] = denominator;
    $[8] = label;
    $[9] = numerator;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <p className={t3}>{t4}{t5}</p>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}